module.exports = __webpack_public_path__ + "static/headphones-banner-sale-section-2807187a22e6e73e8e3211ce7171fcd2.png";